// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorSalesChannels = (client) => ({
    /**
     * `GET /vendor/sales-channels`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListSalesChannels
     * @source packages/modules/b2c-core/src/api/vendor/sales-channels/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/sales-channels", { method: "GET", query, headers }),
});
//# sourceMappingURL=sales-channels.js.map